import { Reducer } from 'redux'
import { DetailPageActions, DetailPageActionTypes } from '../actions'

export type Deeplinking = {
  ready: boolean
}

const initialState = {
  ready: false,
} as Deeplinking

export const reducer: Reducer<Deeplinking, DetailPageActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.DeeplinkingReady:
      return { ready: true }
    default:
      return state
  }
}
